export enum TestId {
  // Navigation
  CONTINUE_BUTTON = "continue-button",
  BACK_BUTTON = "back-button",
  SKIP_BUTTON = "skip-button",

  // Page Section
  PAGE_TITLE_H1 = "page-title-h1",
  PAGE_SUBTITLE = "page-subtitle",

  // Notification
  NOTIFICATION_MESSAGE = "notification-message",

  // Form Fields
  INPUT_FIELD_EMAIL = "input-field-email",
  INPUT_FIELD_FIRST_NAME = "input-field-first-name",
  INPUT_FIELD_LAST_NAME = "input-field-last-name",
  INPUT_FIELD_DATE_OF_BIRTH = "input-field-date-separated",
  INPUT_FIELD_MOBILE_PHONE_NUMBER = "input-field-mobile-phone-number",
  INPUT_FIELD_PERCENTAGE = "input-field-percentage",
  INPUT_FIELD_POSTCODE = "input-field-postcode",
  INPUT_FIELD_CITY = "input-field-city",
  INPUT_FIELD_HEIGHT = "input-field-height",
  INPUT_FIELD_WEIGHT = "input-field-weight",
  INPUT_FIELD_ADDRESS_LINES = "input-field-address-lines",
  INPUT_FIELD_TYPEAHEAD_OCCUPATION = "input-field-typeahead-occupation",
  INPUT_FIELD_ORGANIZATION_NAME = "input-field-organization-name",
  RADIO_FIELD_INSURANCE_TERM_IN_YEARS = "radio-field-insurance-term-in-years",
  RADIO_FIELD_RESIDENCE_PERMIT = "radio-field-residence-permit",
  RADIO_FIELD_UNDERWRITING_QUESTION = "radio-field-underwriting-question",
  RANGE_FIELD_INSURED_SUM = "range-field-insured-sum",
  SELECT_FIELD_NATIONALITY = "select-field-nationality",
  CHECKBOX_ACCEPT_TERMS_OPTION = "checkbox-accept-terms",

  // Error Message
  FORM_FIELD_ERROR_MESSAGE = "form-field-error-message",

  // Beneficiary Page
  BENEFICIARY_PAGE_ADD_BENEFICIARY_BUTTON = "beneficiary-page-add-beneficiary-button",
  BENEFICIARY_PAGE_ITEM_INDEX = "beneficiary-page-item-index",
  BENEFICIARY_PAGE_ITEM_NAME = "beneficiary-page-item-name",
  BENEFICIARY_PAGE_ITEM_PERCENTAGE = "beneficiary-page-data-item-percentage",

  // Overview Page
  BUTTON_EDIT_INSURED_SUM = "button-edit-insured-sum",
  BUTTON_EDIT_INSURANCE_TERM_IN_YEARS = "button-edit-insurance-term-in-years",
  BUTTON_EDIT_PERSONAL_DETAILS = "button-edit-personal-details",
  BUTTON_EDIT_CONTACT_DETAILS = "button-edit-contact-details",
  BUTTON_EDIT_OCCUPATION = "button-edit-occupation",
  BUTTON_EDIT_IS_SMOKER = "button-edit-is-smoker",
  BUTTON_EDIT_NATIONALITY = "button-edit-nationality",
  BUTTON_EDIT_GENDER = "button-edit-gender",
  BUTTON_EDIT_BMI = "button-edit-bmi",
  BUTTON_EDIT_DATE_OF_BIRTH = "button-edit-date-of-birth",
  BUTTON_EDIT_IS_PREGNANT = "button-edit-is-pregnant",
  BUTTON_EDIT_BENEFICIARY = "button-edit-beneficiary",
  BUTTON_EDIT_INSURANCE_START_DATE = "button-edit-insurance-start-date",
  BUTTON_EDIT_INSURANCE_TERMS_ACCEPTED = "button-edit-terms-accepted",
  BUTTON_EDIT_PREMIUM_PAYMENT_FREQUENCY = "button-edit-premium-payment-frequency",
  EDIT_BENEFICIARY_DISPLAY_VALUE = "edit-beneficiary-display-value",
  EDIT_INSURED_SUM_DISPLAY_VALUE = "edit-insured-sum-display-value",
  EDIT_INSURANCE_TERM_IN_YEARS_DISPLAY_VALUE = "edit-insurance-term-in-years-display-value",
  EDIT_INSURANCE_START_DATE_DISPLAY_VALUE = "edit-insurance-start-date-display-value",
  EDIT_CONTACT_DETAILS_DISPLAY_VALUE = "edit-contact-details-display-value",
  EDIT_PERSONAL_DETAILS_DISPLAY_VALUE = "edit-personal-details-display-value",
  EDIT_NATIONALITY_DISPLAY_VALUE = "edit-nationality-display-value",
  EDIT_IS_SMOKER_DISPLAY_VALUE = "edit-is-smoker-display-value",
  EDIT_GENDER_DISPLAY_VALUE = "edit-gender-display-value",
  EDIT_DATE_OF_BIRTH_DISPLAY_VALUE = "edit-date-of-birth-display-value",
  EDIT_OCCUPATION_DISPLAY_VALUE = "edit-occupation-display-value",
  EDIT_BMI_DISPLAY_VALUE = "edit-bmi-display-value",
  EDIT_IS_PREGNANT_DISPLAY_VALUE = "edit-is-pregnant-display-value",
  EDIT_INSURANCE_TERMS_ACCEPTED_DISPLAY_VALUE = "edit-terms-accepted-display-value",
  EDIT_SAVINGS_PLAN_DISPLAY_VALUE = "edit-savings-plan-display-value",
  EDIT_PREMIUM_PAYMENT_FREQUENCY_DISPLAY_VALUE = "edit-premium-payment-frequency-display-value",

  // General
  BUTTON_EDIT_ITEM = "button-edit-item",
  BUTTON_REMOVE_ITEM = "button-remove-item",

  // Uncontrolled Select
  UNCONTROLLED_SELECT_LIST = "uncontrolled-select-list",

  // Premium Page
  BUTTON_CONVERSION_INFO = "button-conversion-info",

  // Pillar 3a
  BUTTON_EDIT_SAVINGS_PLAN = "button-edit-savings-plan",
  BUTTON_EDIT_YEARLY_PREMIUM = "button-edit-yearly-premium",
  INSURANCE_TERM_IN_YEARS_DISPLAY_VALUE = "insurance-term-in-years-display-value",
  INSURANCE_START_DATE_DISPLAY_VALUE = "insurance-start-date-display-value",
  EDIT_YEARLY_PREMIUM_DISPLAY_VALUE = "edit-yearly-premium-display-value",
  BUTTON_EDIT_BROKER = "button-edit-broker",
  EDIT_BROKER_DISPLAY_VALUE = "button-broker-display-value",
  RADIO_FIELD_PREMIUM_PAYMENT_FREQUENCY = "radio-field-premium-payment-frequency",
  RANGE_FIELD_YEARLY_PREMIUM = "range-field-yearly-premium",
  INPUT_FIELD_EMAIL_VERIFICATION_CODE = "input-field-email-verification-code",
  DURATION_IN_YEARS_DISPLAY_VALUE = "duration-in-years-display-value",
}
